<mat-stepper class="waiting-list-stepper" [formGroup]="form" [linear]="true">
  @if (lgpdAccepted() === false) {
    <mat-step>
      <div class="step-info step-lgpd">
        <h3 class="step-title">{{ 'PORTAL.WAITING_LIST.TERMS.TITLE' | translate }}</h3>
        <p class="step-description">
          {{ 'PORTAL.WAITING_LIST.TERMS.DESCRIPTION' | translate }}
        </p>
      </div>
      <div class="step-buttons">
        <button mat-flat-button matStepperNext color="primary" (click)="onLgpdAccepted()">
          <span>{{ 'PORTAL.WAITING_LIST.TERMS.ACCEPT' | translate }}</span>
        </button>
        <button mat-stroked-button (click)="return.emit()">
          <span>{{ 'PORTAL.WAITING_LIST.TERMS.BACK' | translate }}</span>
        </button>
      </div>
    </mat-step>
  }
  <mat-step [stepControl]="form.controls.phone">
    <div class="step-info">
      <h3 class="step-title">{{ 'PORTAL.WAITING_LIST.PHONE.TITLE' | translate }}</h3>
      <p class="step-description">
        {{ 'PORTAL.WAITING_LIST.PHONE.DESCRIPTION' | translate }}
      </p>
    </div>

    <madero-phone-country-input [phoneControl]="form.controls.phone"> </madero-phone-country-input>

    <div class="step-buttons">
      <button
        mat-flat-button
        matStepperNext
        color="primary"
        (click)="form.controls.phone.markAsTouched()">
        <span>{{ 'PORTAL.WAITING_LIST.PHONE.CONTINUE' | translate }}</span>
      </button>
      <button mat-stroked-button (click)="return.emit()">
        <span>{{ 'PORTAL.WAITING_LIST.PHONE.BACK' | translate }}</span>
      </button>
    </div>
  </mat-step>
  <mat-step [stepControl]="form.controls.name">
    <div class="step-info">
      <h3 class="step-title">{{ 'PORTAL.WAITING_LIST.NAME.TITLE' | translate }}</h3>
    </div>
    <mat-form-field>
      <mat-label>{{ 'PORTAL.WAITING_LIST.NAME.LABEL' | translate }}</mat-label>
      <input
        matInput
        type="text"
        [placeholder]="'PORTAL.WAITING_LIST.NAME.PLACEHOLDER' | translate"
        formControlName="name"
        maxlength="50" />
      @if (form.controls.name.hasError('required')) {
        <mat-error>{{ 'PORTAL.WAITING_LIST.NAME.REQUIRED' | translate }}</mat-error>
      }
      @if (form.controls.name.hasError('maxlength')) {
        <mat-error>{{ 'PORTAL.WAITING_LIST.NAME.MAX_LENGTH' | translate }}</mat-error>
      }
    </mat-form-field>
    <div class="step-buttons">
      <button mat-flat-button matStepperNext color="primary">
        <span>{{ 'PORTAL.WAITING_LIST.NAME.CONTINUE' | translate }}</span>
      </button>
      <button mat-stroked-button matStepperPrevious>
        <span>{{ 'PORTAL.WAITING_LIST.NAME.BACK' | translate }}</span>
      </button>
    </div>
  </mat-step>
  <mat-step [stepControl]="form.controls.count">
    <div class="step-info">
      <h3 class="step-title">{{ 'PORTAL.WAITING_LIST.QUANTITY.TITLE' | translate }}</h3>
      <p class="step-description">{{ 'PORTAL.WAITING_LIST.QUANTITY.SUBTITLE' | translate }}</p>
    </div>
    <mat-form-field>
      <mat-label>{{ 'PORTAL.WAITING_LIST.QUANTITY.LABEL' | translate }}</mat-label>
      <input
        matInput
        type="text"
        [placeholder]="'PORTAL.WAITING_LIST.QUANTITY.PLACEHOLDER' | translate"
        formControlName="count"
        mask="09" />
      @if (form.controls.count.hasError('required')) {
        <mat-error>{{ 'PORTAL.WAITING_LIST.QUANTITY.REQUIRED' | translate }}</mat-error>
      }
      @if (form.controls.count.hasError('max')) {
        <mat-error>
          {{ 'PORTAL.WAITING_LIST.QUANTITY.MAX_QUANTITY' | translate }}
          {{ form.controls.count.getError('max').max }}
        </mat-error>
      }
      @if (form.controls.count.hasError('min')) {
        <mat-error>
          {{ 'PORTAL.WAITING_LIST.QUANTITY.MIN_QUANTITY' | translate }}
          {{ form.controls.count.getError('min').min }}
        </mat-error>
      }
    </mat-form-field>
    <div class="step-buttons">
      <button mat-flat-button matStepperNext color="primary">
        <span>{{ 'PORTAL.WAITING_LIST.QUANTITY.CONTINUE' | translate }}</span>
      </button>
      <button mat-stroked-button matStepperPrevious>
        <span>{{ 'PORTAL.WAITING_LIST.QUANTITY.BACK' | translate }}</span>
      </button>
    </div>
  </mat-step>
  <mat-step [stepControl]="form.controls.priorities" formGroupName="priorities">
    <div class="step-info">
      <h3 class="step-title">{{ 'PORTAL.WAITING_LIST.PRIORITY.TITLE' | translate }}</h3>
      <p class="step-description">
        {{ 'PORTAL.WAITING_LIST.PRIORITY.DESCRIPTION' | translate }}
      </p>
    </div>
    <mat-radio-group
      [attr.aria-label]="'PORTAL.WAITING_LIST.PRIORITY.ERROR' | translate"
      formControlName="priority"
      color="primary"
      class="radio-group">
      <mat-radio-button [value]="true">{{
        'PORTAL.WAITING_LIST.PRIORITY.OPTIONS.YES' | translate
      }}</mat-radio-button>
      <mat-radio-button [value]="false">{{
        'PORTAL.WAITING_LIST.PRIORITY.OPTIONS.NO' | translate
      }}</mat-radio-button>
    </mat-radio-group>
    @if (priorities.controls.priority.touched && priorities.controls.priority.hasError('required')) {
      <mat-error>{{ 'PORTAL.WAITING_LIST.PRIORITY.ERROR' | translate }}</mat-error>
    }
    @if (priorities.value.priority) {
      <div class="priority">
        <h4 class="priority-title">{{ 'PORTAL.WAITING_LIST.PRIORITY.SELECT_OPTIONS' | translate }}</h4>
        <div
          class="checkbox-group"
          [class.invalid]="
            priorities.controls.priorityTypes.touched &&
            priorities.controls.priorityTypes.hasError('required')
          ">
          @for (priorityType of priorityTypes(); track priorityType) {
            <mat-checkbox
              color="primary"
              [value]="priorityType.toString()"
              (change)="onCheckPriorityChange($event)">
              {{ priorityTypesDetails[priorityType].labelKey | translate }}
            </mat-checkbox>
          }
        </div>
        @if (
          priorities.controls.priorityTypes.touched &&
          priorities.controls.priorityTypes.hasError('required')
        ) {
          <mat-error>{{ 'PORTAL.WAITING_LIST.PRIORITY.ERROR' | translate }}</mat-error>
        }
        @if (priorities.value.priorityTypes?.includes(priorityTypesEnum.Other)) {
          <div class="other-priority">
            <mat-form-field>
              <mat-label>{{
                'PORTAL.WAITING_LIST.PRIORITY.OTHER_PRIORITY_LABEL' | translate
              }}</mat-label>
              <input
                matInput
                type="text"
                [placeholder]="'PORTAL.WAITING_LIST.PRIORITY.OTHER_PRIORITY_PLACEHOLDER' | translate"
                formControlName="otherPriorityLabel" />
              @if (priorities.controls.otherPriorityLabel.hasError('required')) {
                <mat-error>{{
                  'PORTAL.WAITING_LIST.PRIORITY.OTHER_PRIORITY_REQUIRED' | translate
                }}</mat-error>
              }
            </mat-form-field>
          </div>
        }
      </div>
    }
    <div class="step-buttons">
      <button mat-flat-button matStepperNext color="primary" (click)="priorities.markAllAsTouched()">
        <span>{{ 'PORTAL.WAITING_LIST.PRIORITY.CONTINUE' | translate }}</span>
      </button>
      <button mat-stroked-button matStepperPrevious>
        <span>{{ 'PORTAL.WAITING_LIST.PRIORITY.BACK' | translate }}</span>
      </button>
    </div>
  </mat-step>
  @if (branchAllowPet()) {
    <mat-step [stepControl]="form.controls.pet">
      <div class="step-info">
        <h3 class="step-title">{{ 'PORTAL.WAITING_LIST.PET.TITLE' | translate }}</h3>
        <p class="step-description">
          {{ 'PORTAL.WAITING_LIST.PET.DESCRIPTION' | translate }}
        </p>
      </div>
      <mat-radio-group
        [attr.aria-label]="'PORTAL.WAITING_LIST.PET.ERROR' | translate"
        formControlName="pet"
        color="primary"
        class="radio-group">
        <mat-radio-button [value]="true">{{
          'PORTAL.WAITING_LIST.PET.YES' | translate
        }}</mat-radio-button>
        <mat-radio-button [value]="false">{{
          'PORTAL.WAITING_LIST.PET.NO' | translate
        }}</mat-radio-button>
      </mat-radio-group>
      @if (form.controls.pet.touched && form.controls.pet.hasError('required')) {
        <mat-error>{{ 'PORTAL.WAITING_LIST.PET.ERROR' | translate }}</mat-error>
      }
      <div class="step-buttons">
        <button
          mat-flat-button
          matStepperNext
          color="primary"
          (click)="form.controls.pet.markAsTouched()">
          <span>{{ 'PORTAL.WAITING_LIST.PET.CONTINUE' | translate }}</span>
        </button>
        <button mat-stroked-button matStepperPrevious>
          <span>{{ 'PORTAL.WAITING_LIST.PET.BACK' | translate }}</span>
        </button>
      </div>
    </mat-step>
  }
  <mat-step>
    <div class="step-info">
      <h3 class="step-title">{{ 'PORTAL.WAITING_LIST.REVIEW.TITLE' | translate }}</h3>
    </div>
    <div class="resume">
      <div class="resume-info">
        <h2>{{ 'PORTAL.WAITING_LIST.REVIEW.NAME' | translate }}</h2>
        <p>{{ form.value.name }}</p>
      </div>
      <div class="resume-info">
        <h2>{{ 'PORTAL.WAITING_LIST.REVIEW.PHONE' | translate }}</h2>
        <p>{{ form.value.phone | countryPhone }}</p>
      </div>
      <div class="resume-info">
        <h2>{{ 'PORTAL.WAITING_LIST.REVIEW.QUANTITY' | translate }}</h2>
        <p>{{ form.value.count }}</p>
      </div>
      <div class="resume-info">
        <h2>{{ 'PORTAL.WAITING_LIST.REVIEW.PRIORITY' | translate }}</h2>
        <p>
          @if (priorities.value.priority) {
            {{ 'PORTAL.WAITING_LIST.REVIEW.PRIORITY_YES' | translate }} {{ priorityTypesDescription }}
          } @else {
            {{ 'PORTAL.WAITING_LIST.REVIEW.PRIORITY_NO' | translate }}
          }
        </p>
      </div>
      <div class="resume-info">
        <h2>{{ 'PORTAL.WAITING_LIST.REVIEW.PET' | translate }}</h2>
        <p>
          @if (branchAllowPet() === false) {
            {{ 'PORTAL.WAITING_LIST.REVIEW.PET_NOT_ALLOWED' | translate }}
          } @else {
            {{
              (form.value.pet
                ? 'PORTAL.WAITING_LIST.REVIEW.PET_YES'
                : 'PORTAL.WAITING_LIST.REVIEW.PET_NO'
              ) | translate
            }}
          }
        </p>
      </div>
    </div>
    <div class="step-buttons">
      <button
        mat-flat-button
        color="primary"
        (click)="onSubmitEntry()"
        [disabled]="portalDataService.isInsertingEntry()">
        @if (portalDataService.isInsertingEntry()) {
          <div class="c-btn-spinner">
            <mat-spinner class="c-btn-spinner__spinner" color="primary"></mat-spinner>
            <span>{{ 'PORTAL.WAITING_LIST.REVIEW.INSERTING_ENTRY' | translate }}</span>
          </div>
        } @else {
          <span>{{ 'PORTAL.WAITING_LIST.REVIEW.CONFIRM' | translate }}</span>
        }
      </button>
      <button mat-stroked-button matStepperPrevious [disabled]="portalDataService.isInsertingEntry()">
        <span>{{ 'PORTAL.WAITING_LIST.REVIEW.BACK' | translate }}</span>
      </button>
    </div>
  </mat-step>
</mat-stepper>
